import { render, staticRenderFns } from "./Repairability.vue?vue&type=template&id=38eb28e6&scoped=true"
import script from "./Repairability.vue?vue&type=script&lang=js"
export * from "./Repairability.vue?vue&type=script&lang=js"
import style0 from "./Repairability.vue?vue&type=style&index=0&id=38eb28e6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38eb28e6",
  null
  
)

export default component.exports